import { track } from "jiffy-analytics";
import { observeElementVisibility, isScrollOnTop } from "common/utils/ui/visibility";

import "./product-details-features.scss";

export default () => {
  if (isScrollOnTop()) {
    observeElementVisibility(
      ".product-details-features",
      (entries, scrolled) => {
        track("viewed_on_pdp", { target: "product_features", scrolled });
      },
      { mobileOnly: true, once: true }
    );
  }
};
